<div *ngIf="pannes.length > 0">
    Codes associés :
    <span *ngFor="let panne of pannes;let last = last;">
        <strong>{{panne}}</strong>
        <span *ngIf="!last"> - </span>
    </span>
    <br/>
    Pannes depuis les 30 derniers jours
</div>

<div *ngIf="pannes.length < 1">
    <strong>Aucun code panne associé</strong>
</div>
<ng-container *ngIf="pannes.length > 0">
    <mat-table [dataSource]="callStats">
        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
            <mat-cell *matCellDef="let call"> {{getNiceDate(call.DEBUT)}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="numSerie">
            <mat-header-cell *matHeaderCellDef> Numéro de série </mat-header-cell>
            <mat-cell *matCellDef="let call"> {{call.NUMERO}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="nom">
            <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
            <mat-cell *matCellDef="let call"> {{call.NOM}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
            <mat-cell *matCellDef="let call"> {{call.ACTION}} </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumn"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['date', 'numSerie', 'nom', 'action'] ;"></mat-row>
    </mat-table>
</ng-container>